module.exports = __webpack_public_path__ + "static/media/top_dance_academy.6341ece4.md";